/**
 * record-list-steps.js
 */

import React from 'react';
import TourStep from '../tour-step';
import tourStepProps from '../tour-step-props';


export default [
  {
    target: "[data-testid='records-list']",
    title: "Managing Your Records",
    ...tourStepProps,
    placementBeacon: 'top',
    content: (
      <TourStep name='Record List Tour'>
        This is where you view, edit, delete and print your records.
        Blue rows are exercise records while the grey rows are deployments.
        You can click anywhere on a row to open the <strong>Record Editor</strong> for that specific record.
      </TourStep>
    ),
  },
  {
    target: "button[aria-label$='options']",
    title: "Record Menu",
    ...tourStepProps,
    placement: 'top',
    spotlightClicks: true,
    content: (
      <TourStep name='Record List Tour'>
        Click this button to see the record's dropdown menu.
        This menu includes important functions such as printing or deleting a single record.
        Click this button to open the dropdown menu now.
        Click it again to close it.
      </TourStep>
    ),
  },
  {
    target: "[data-testtype='record-row-checkbox']",
    title: "Select Multiple Records",
    ...tourStepProps,
    spotlightClicks: true,
    content: (
      <TourStep name='Record List Tour'>
        To print multiple records at the same time you'll need to select each of them using these checkboxes.
        Next, click the Report button above the calendar to see your combined report.<br /><br />
        Note that you can't select incomplete records and all of the records you check must be of the same type (either Exercise or Deployment).
      </TourStep>
    ),
  },
  {
    target: "[data-testid='records-filter']",
    title: "Filter Your Records",
    ...tourStepProps,
    content: (
      <TourStep name='Record List Tour'>
        Sometimes you need to print a lot of records at once.
        In that case it's best to first search for the type of records that you want to print using the <strong>Filter Form</strong>.
        You can open the detailed filters to find, for example, "all tracking exercises in the last 2 years" or just click a standard filter like "Training" so you see all of your exercises.
      </TourStep>
    ),
  },
];
